module.exports = "data:image/webp;base64,UklGRkIAAABXRUJQVlA4IDYAAADwAgCdASoCACEAPtFeqE4oJSOiKqgBABoJYwDG9B3QQAD+Ex6qp6/G7/8Q5/W3/cpnK0ewwAA="